import { render, staticRenderFns } from "./MakeModelBotComponent.vue?vue&type=template&id=66b5704d"
import script from "./MakeModelBotComponent.vue?vue&type=script&lang=ts"
export * from "./MakeModelBotComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports